import gql from 'graphql-tag';

export const GetDraftParentQuery = gql`
	query GetDraftParentQuery($contentId: ID!) {
		content(id: $contentId, status: ["draft"]) {
			nodes {
				id
				ancestors {
					id
				}
			}
		}
	}
`;
